import service from './service.js';

export class FileInfoService {
    
    recordFileInfo(dropzoneId, fileSize, fileFormat, fileName) {
        //returns Promise object
        return service.getRestClient().post('/api/recordFileInfo', JSON.stringify({
            dropzoneId: dropzoneId, 
            fileSize: fileSize, 
            fileFormat: fileFormat, 
            fileName: fileName
        }));
    }

}

export default (new FileInfoService());